import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { AdminUser } from '../admin-user.model';

@JsonObject('AdminUserResultsResponse')
export class AdminUserResultsResponse extends ApiResultsResponse<AdminUser> {

  @JsonProperty('results', [AdminUser])
  override results: AdminUser[] = [];
}
